import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';
import { collectionAction } from "ember-api-actions";

const TYPES = {
  APPLICATION : 'Application',
  ASSIGNMENT : 'Assignment',
  PAYOUT_ACCOUNT : 'PayoutAccount',
};

export const ACTIVITY_FEED_ITEM = {
  TYPES,
};

const ActivityFeedItem = ShModel.extend({
  body: attr('string'),
  feedableType: attr('string'),
  feedableId: attr('string'),
  readAt: attr('date'),
  title: attr('string'),
  subtitle: attr('string'),
  createdAt: attr('date'),
  user: belongsTo('user', { async: false }),
  otherUserImage: belongsTo('image', { async: false }),

  /**
   * Custom endpoint to mark a set of activity-feed-items as read
   */
  markRead: collectionAction({ path: 'mark-read' })
});

export default ActivityFeedItem;
